import { render, staticRenderFns } from "./recent_expired_member_view.vue?vue&type=template&id=4e49e681&scoped=true"
import script from "./recent_expired_member_view.vue?vue&type=script&lang=js"
export * from "./recent_expired_member_view.vue?vue&type=script&lang=js"
import style0 from "./recent_expired_member_view.vue?vue&type=style&index=0&id=4e49e681&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49e681",
  null
  
)

export default component.exports